import script from "./ReleaseAnnouncementDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ReleaseAnnouncementDialog.vue?vue&type=script&setup=true&lang=js"

import "./ReleaseAnnouncementDialog.vue?vue&type=style&index=0&id=d17b7eea&lang=css"

const __exports__ = script;

export default __exports__